import React from 'react';

const SummaryInfo = () => {
  return (
    <div className="ie--summary--info">
      <h3 className="ie--summary--heading">What{"'"}s Next?</h3>
      <ul className="ie--summary--info--list">
        <li>
          Please review details and hit <strong>“Submit for Approval”</strong>.
        </li>
        <li>
          We will email your company’s dedicated Account Manager to approve each
          Turn-Key Omnibus.
        </li>
        <li>
          Our survey experts will review your questionnaire to ensure it follows
          best practices and send an email with suggested edits, if necessary.
          When the survey meets all criteria it will be launched and you will be
          notified via email, when it is ready.
        </li>
      </ul>
      <div className="ie--summary--info--notes">
        Please note: the estimated cost below is based on a maximum of 10
        questions. Additional questions may cause an increase in the final
        estimate. Your dedicated account manager will contact you after
        submission to confirm your approval of all charges prior to fielding.
      </div>
    </div>
  );
};

export default SummaryInfo;
